import { Dispatch, SetStateAction } from 'react';

import styled from '@emotion/styled';

import { Input, InputContainer, InputLabel, InputWrapper } from './FormField';

interface IReadOnlyBlurTextField {
  label?: string;
  value: string;
  placeholder?: string;
  className?: string;
  id?: string;
  showKey?: boolean;
  setShowKey?: Dispatch<SetStateAction<boolean>>;
}

export const ReadOnlyBlurTextField: React.FC<IReadOnlyBlurTextField> = ({
  label,
  value,
  placeholder,
  className,
  id,
  showKey = false,
  setShowKey,
}) => {
  const handleToggle = () => {
    if (setShowKey) setShowKey(!showKey);
  };

  return (
    <InputWrapper className={className}>
      {label && <InputLabel htmlFor={id}>{label}</InputLabel>}
      <InputContainer>
        <Input
          id={id}
          type={showKey ? 'text' : ''}
          value={value}
          placeholder={placeholder}
          readOnly
        />
        <BlurryBox
          onClick={handleToggle}
          className={showKey ? '' : 'blur'}
        ></BlurryBox>
      </InputContainer>
    </InputWrapper>
  );
};

const BlurryBox = styled.div`
  margin: 8px;
  cursor: pointer;

  &.blur {
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.1);
  }
`;
